export function _t(key, variables) {
    let str = key;

    if (key in LANG) {
        str = LANG[key];
    } else {
        if (!(key in STRING_LIST_WITHOUT_TRANSLATION)) {
            STRING_LIST_WITHOUT_TRANSLATION[key] = true;
        }
    }

    for (const variable in variables) {
        if (variables.hasOwnProperty(variable)) {
            str = str.replace('%' + variable + '%', variables[variable]);
        }
    }

    return str;
}

export function getStringListWithoutTranslation() {
    return STRING_LIST_WITHOUT_TRANSLATION;
}